export const createProductPhysicalMedia = `mutation ($data: prodigio_product_physical_medias_insert_input!) {
    item: insert_prodigio_product_physical_medias_one(object: $data) {
      media {
        id
        url
      }
    }
  }
  `;
